import React from "react";
import Navbar from "../../common/Navbar/Navbar";
import "./requestsheader.css";
import NewRequest from "../NewRequest/NewRequest";
import SendRequest from "../SendRequest/SendRequest";
import DataRequestsTooltips from "../DataRequestsTooltips/DataRequestsTooltips";

/**
 * Buttons to add a New Request and Send a Message
 */
export default function RequestsHeader({
  handleNewRequest,
  handleSendNewRequest,
  handleArrowBackClick,
  isSendButtonEnabled,
}) {
  return (
    <>
      <Navbar onArrowBackClick={handleArrowBackClick} />
      <div className="grid-container-members">
        <div className="header">
          <div className="header-datarequests">Data Requests</div>

          <div className="header-datarequests-buttons">
            {/* Tooltips for DataRequests */}
            <DataRequestsTooltips />
            {/* Button to add new Data Request */}
            <NewRequest handleNewRequest={handleNewRequest} />
            {/* Button to send a new Request to the External Client */}
            <SendRequest
              handleSendNewRequest={handleSendNewRequest}
              isSendButtonEnabled={isSendButtonEnabled}
            />
          </div>
        </div>
      </div>
    </>
  );
}
